<template>
    <div v-if="isVisible" id="ybh-popup">
        <table>
            <tr>
                <td
                    class="hover-setting1"
                    @click="onClickOpenFileChooser"
                    id="td1"
                    title="画像を変更"
                >
                    <a>画像変更</a>
                </td>
            </tr>
            <tr>
                <td
                    class="hover-setting1"
                    :class="{ disabled: !imageFilename }"
                    @click="onClickDelete()"
                    id="td2"
                    title="画像を削除"
                >
                    <a>画像削除</a>
                </td>
            </tr>
            <tr>
                <td
                    class="hover-setting1"
                    :class="{ disabled: !imageFilename }"
                    @click="onClickChangePosition()"
                    id="td4"
                    title="画像位置調整"
                >
                    <a>画像位置調整</a>
                </td>
            </tr>
            <tr>
                <td
                    class="hover-setting1"
                    @click="onClickCancel()"
                    id="td3"
                    title="キャンセル"
                >
                    <a>キャンセル</a>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import { onBeforeUpdate, onMounted, onUpdated, computed, reactive } from "vue";
import { ref, defineComponent } from "vue";

export default defineComponent({
    props: {
        imageFilename: String,
        isVisible: Boolean,
    },
    setup(props, context) {
        const onClickDelete = () => {
            context.emit("delete:image");
        };
        const onClickChangePosition = () => {
            context.emit("change:position");
        };
        const onClickCancel = () => {
            context.emit("close");
        };
        const onClickOpenFileChooser = () => {
            context.emit("open:file-chooser");
        };
        return {
            onClickDelete,
            onClickChangePosition,
            onClickCancel,
            onClickOpenFileChooser,
        };
    },
});
</script>
